var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronDoubleDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_chevron-double-down",
    "data-name": "Icon - chevron-double-down",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.87,
    height: 14.003,
    viewBox: "0 0 16.87 14.003",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-double-down",
    d: "M17.611,71.92,9.633,79.9a.454.454,0,0,1-.643,0L1.012,71.92a.454.454,0,0,1,0-.643l.268-.268a.454.454,0,0,1,.643,0L9.312,78.4,16.7,71.012a.454.454,0,0,1,.643,0l.268.268A.453.453,0,0,1,17.611,71.92Zm0,4.2-.268-.268a.454.454,0,0,0-.643,0L9.312,83.24,1.92,75.852a.454.454,0,0,0-.643,0l-.268.268a.454.454,0,0,0,0,.643l7.978,7.982a.454.454,0,0,0,.643,0l7.978-7.982A.455.455,0,0,0,17.611,76.117Z",
    transform: "translate(-0.875 -70.875)",
    fill: "#1976d2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronDoubleDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - chevron-double-down.d98b4125da5726f12cbe2542d0e11217.svg";